module.exports = __webpack_public_path__ + "static/media/rakbank.a3f7506e.svg";